import { render, staticRenderFns } from "./CarouselPartiners.vue?vue&type=template&id=5ed1ad8f&scoped=true"
import script from "./CarouselPartiners.vue?vue&type=script&lang=js"
export * from "./CarouselPartiners.vue?vue&type=script&lang=js"
import style0 from "./CarouselPartiners.vue?vue&type=style&index=0&id=5ed1ad8f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed1ad8f",
  null
  
)

export default component.exports